import { MIGRATION_PATHS } from "src/templates/constants";
import { normalizePathname } from "src/lib/normalizePathname";

export const isMigrationPage = (pathname: string): boolean =>
  normalizePathname(pathname) in MIGRATION_PATHS;
